import moment from 'moment';

/**
 * validate DOB with yap
 * @param value
 * @param setDOBError
 * @return boolean,
 *
 */
export const validateDOB = (value: any, setDOBError: any) => {
  if(!value){
    return true;
  }
  if (moment(value).isValid()) {
    return true;
  } else {
    setDOBError('Invalid Date of Birth');
    return false;
  }
};
